// extracted by mini-css-extract-plugin
export default {"customizedWidth":"admin-change-contract-license-dialog_customizedWidth__Ks2i-"};